
import { defineComponent, PropType, reactive } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// composable
import { RaketaRPKT } from '@/core/types/rpk.types'
import { rpk } from '@/core/realisations/rpk.realisation'

export default defineComponent({
    components: {
        'the-button': TheButton,
        Cheap,
    },
    props: {
        item: {
            type: Object as PropType<RaketaRPKT>,
            required: true,
        },
    },
    setup(props) {
        const state = reactive({
            is_loading: false,
        })

        const exportExcel = async () => {
            try {
                state.is_loading = true
                const response = await rpk.exportExcelRaketa(props.item.id)
                const download_url = window.URL.createObjectURL(response)
                const link = document.createElement('a')
                link.href = download_url
                link.target = '_blank'
                link.setAttribute('download', `РПК ID: ${props.item.id}`)
                document.body.appendChild(link)
                link.click()
                link.remove()
            } catch (e) {
                console.log(e)
            } finally {
                state.is_loading = false
            }
        }

        const getStatusColor = (id: number) => {
            if (id === 8) return 'orange'
            if (id === 1) return 'yellow'
            if (id === 2) return 'green'

            return ''
        }

        const formatDate = (dateStr: string) => {
            if (!dateStr) return '-'

            const dateFirst = dateStr.split(' ')[0]
            return dateFirst.split('-').reverse().join('.')
        }

        return { state, exportExcel, getStatusColor, formatDate }
    },
})
